export function categoriesReducer(state = {
    PARENT: {},
    CHILD: {},
    NAMES: {}, // list of all categories with info
    ALL:{}, // show in selects
    LIST:{}, // display categories List
},{
    type,
    payload
}){
    
    switch(type){
        
        case "NEW_CATEGORY":     
        case "UPDATE_CATEGORY":     
            let list = Object.assign({}, state);
            if(payload.is_parent){
                list.NAMES[payload.category_id] = payload
                list.PARENT[payload.category_id] = payload
            } else {
                list.CHILD[payload.category_id] = payload
                
                if(list.ALL[payload.category_parent]){
                    list.ALL[payload.category_parent].push(payload.category_id)
                    
                } else {
                    list.ALL[payload.category_parent] = [payload.category_id]
                }
            }
            return list

        case "REFETCH_CATEGORIES":

            return payload

        case "GET_PARENT_CATEGORIES":
            let list2 = Object.assign({}, state);
            list2.PARENT = payload
            list2.NAMES = Object.assign(list2.NAMES, payload)
            return list2
            
        case "GET_CHILD_CATEGORIES":
            let list3 = Object.assign({}, state);
            list3.CHILD = payload
            list3.NAMES = Object.assign(list3.NAMES, payload)
            Object.values(payload).forEach( cat => {
                if(!cat.category_sub_parent){

                    if(list3.LIST[cat.category_parent]){
                        list3.LIST[cat.category_parent].push(cat.category_id)
                        
                    } else {
                        list3.LIST[cat.category_parent] = [cat.category_id]
                    }
                } else {

                    if(list3.LIST[cat.category_sub_parent]){
                        list3.LIST[cat.category_sub_parent].push(cat.category_id)
                    } else {
                        list3.LIST[cat.category_sub_parent] = [cat.category_id]
    
                    }
                }

                if(list3.ALL[cat.category_parent]){
                    list3.ALL[cat.category_parent].push(cat.category_id)
                    
                } else {
                    list3.ALL[cat.category_parent] = [cat.category_id]
                }
            })
            return list3
        case "GET_PARENT_SPENT":
            let list4 = Object.assign({}, state);
            // console.log({payload});
            // Object.values(payload).forEach( cat => {
            Object.keys(list4.NAMES).forEach( cat => {
                if ( list4.PARENT[cat] ){
                    list4.PARENT[cat].budget_spent = 0
                }
                if ( list4.CHILD[cat] ){
                    list4.CHILD[cat].budget_spent = 0
                }
                // list4.NAMES[cat.category_parent].budget_spent = 0
            })
            Object.values(payload).forEach( cat => {
                list4.CHILD[cat.category_id].budget_spent = cat.budget_spent
                list4.PARENT[cat.category_parent].budget_spent += cat.budget_spent
            })
            return list4

        case "UPDATE_ACTIVE_BUDGET":
            let list5 = Object.assign({}, state);
            Object.keys(payload).forEach( catID => {
                list5.PARENT[catID].budget_active = payload[catID]
                list5.NAMES[catID].budget_active = payload[catID]
            })
            return list5

        case "TOGGLE_CATEGORY_ACTIVE":
            let list6 = Object.assign({}, state);
            const catId = payload.category_id;
            const newActive = payload.is_active;
            if (list6.NAMES[catId]) {
                list6.NAMES[catId] = { ...list6.NAMES[catId], is_active: newActive };
            }
            if (list6.PARENT[catId]) {
                list6.PARENT[catId] = { ...list6.PARENT[catId], is_active: newActive };
                const childIds = list6.ALL[catId] || [];
                childIds.forEach(childId => {
                    if (list6.CHILD[childId]) {
                        list6.CHILD[childId] = { ...list6.CHILD[childId], is_active: newActive };
                    }
                    if (list6.NAMES[childId]) {
                        list6.NAMES[childId] = { ...list6.NAMES[childId], is_active: newActive };
                    }
                });
            }
            if (list6.CHILD[catId]) {
                list6.CHILD[catId] = { ...list6.CHILD[catId], is_active: newActive };
            }
            return list6

        default:
            return state;
    }
    
}